export default __webpack_public_path__ + "static/contest-widget-bg-468265df9a22eccc302824bd823612f3.jpg";